(
    /** @param $ jQuery */
    function ($) {
        $.extend($, {
            datatable: {
                renders: {
                    boolean: function (field, icon, color) {
                        return function (data, type) {
                            if (type === "display" || type === "export") {
                                if (data) {
                                    let value = data[field];
                                    let htmlTrue = '<span class="badge badge-roundless bg-' + color + ' bg-font-' + color + '"><i class="' + icon + '"></i></span>';
                                    return value === true ? htmlTrue : '';
                                } else {
                                    return "";
                                }
                            } else {
                                return data[field];
                            }
                        }
                    },

                    booleanOnlyTrue: function () {
                        return function (data, type) {
                            if (type === "display" || type === "export") {
                                let htmlTrue = '<span class="glyphicon glyphicon-ok" aria-hidden="true" style="color: #26C281!important;"></span>';
                                return data === true ? htmlTrue : '';
                            } else {
                                return data;
                            }
                        }
                    },

                    /**
                     * Retorna a string com proteções contra ataques XSS
                     *
                     * @returns {Function}
                     */
                    text: function () {
                        return $.fn.dataTable.render.text()
                    },

                    /**
                     * Retorna um renderizador para um número que pode ser inteiro ou float
                     *
                     * @param thousandsSeparator string
                     * @param decimalSeparator string
                     * @param floatingPointPrecision int [OPTIONAL]
                     * @param prefix string [OPTIONAL]
                     * @param suffix string [OPTIONAL]
                     *
                     * @returns {Function}
                     */
                    number: function (thousandsSeparator, decimalSeparator, floatingPointPrecision, prefix, suffix) {
                        return $.fn.dataTable.render.number(thousandsSeparator, decimalSeparator, floatingPointPrecision, prefix, suffix);
                    },

                    /**
                     * Retorna um renderizador exclusivamente para dinheiro.
                     *
                     * @param thousandsSeparator string
                     * @param decimalSeparator string
                     * @param floatingPointPrecision int [OPTIONAL]
                     * @param prefix string [OPTIONAL]
                     * @param suffix string [OPTIONAL]
                     *
                     * @returns {Function}
                     */
                    money: function (thousandsSeparator, decimalSeparator, floatingPointPrecision, prefix, suffix) {
                        return function (data, type) {
                            if (type === "display" || type === "exports") {
                                return $.fn.dataTable.render.number(thousandsSeparator, decimalSeparator, floatingPointPrecision, prefix, suffix).display(data);
                            } else {
                                return parseFloat(data);
                            }
                        };
                    },

                    /**
                     * Retorna um renderizador para data em formato local.
                     *
                     * @returns {Function}
                     */
                    date: function () {
                        return function (data, type) {
                            if (type === "display" || type === "export") {
                                if (data) {
                                    // TODO: converter pra zona do usuário logado
                                    return moment.parseZone(data).format("DD/MM/YYYY");
                                } else {
                                    return "";
                                }
                            } else {
                                return data;
                            }
                        }
                    },

                    /**
                     * Retorna um renderizador para data em formato local.
                     *
                     * @oaram {string=} [format=DD/MM/YYYY HH:mm:ss]
                     * @returns {Function}
                     */
                    datetime: function (format) {
                        return function (data, type) {
                            if (type === "display" || type === "export") {
                                if (data) {
                                    // TODO: converter pra zona do usuário logado
                                    return moment.parseZone(data).format(format ? format : "DD/MM/YYYY HH:mm:ss");
                                } else {
                                    return "";
                                }
                            } else {
                                return data;
                            }
                        }
                    }
                },

                columns: {
                    /**
                     * Retorna uma coluna no ponto para
                     * implementar o auto-number.
                     */
                    autonumber: {
                        "defaultContent": "",
                        "orderable": false,
                        "searchable": false,
                        "title": "#",
                        "width": 30,
                        "className": "center"
                    }
                },

                functions: {
                    /**
                     * Habilita auto-number numa determinada coluna.
                     *
                     * Use apenas para processamento local (serverSide=false).
                     *
                     * @param dt
                     * @param columnIndex
                     * @param className
                     */
                    autonumber: function (dt, columnIndex, className) {
                        dt.on('draw.dt', function () {
                            let nodes = dt.column(columnIndex, {
                                order: 'applied',
                                search: 'applied'
                            }).nodes();

                            nodes.each(function (cell, i) {
                                cell.innerHTML = i + 1;

                                if (className) {
                                    $(cell).addClass(className);
                                }
                            });
                        }).draw();
                    }
                },

                dom: {
                    /**
                     * Configura o DOM para mostrar apenas a tabela.
                     */
                    onlyTable: '<"row"<"col-sm-12"rt>>',

                    /**
                     * Configura o DOM com pesquisa em cima e informação embaixo
                     */
                    infoAndSearchTop: '<"row"<"col-sm-6"i><"col-sm-6"f>><"row"<"col-sm-12"rt>>',

                    /**
                     * Configura o DOM com pesquisa em cima e informação embaixo
                     */
                    searchTopAndInfoBottom: '<"row"<"col-sm-12"f>><"row"<"col-sm-12"rt>><"row"<"col-sm-12"i>>',

                    /**
                     * Configura o DOM com pesquisa em cima e informação e paginação embaixo
                     */
                    searchTopAndInfoPaginationBottom: '<"row"<"col-sm-12"f>><"row"<"col-sm-12"rt>><"row"<"col-sm-6"i><"col-sm-6"p>>',

                    /**
                     * Configura o DOM com botões e pesquisa em cima, informações e páginação embaixo
                     */
                    complete: '<"row"<"col-sm-6"B><"col-sm-6"f>><"row"<"col-sm-12"rt>><"row"<"col-sm-6"i><"col-sm-6"p>>'
                }
            },

            editor: {
                buttons: {
                    getInsertButtons: function (editor) {
                        return [
                            {
                                "label": "Inserir",
                                "fn": function () { editor.submit() }
                            },
                            {
                                "label": "Cancelar",
                                "fn": function () { this.close() }
                            }
                        ];
                    },

                    getUpdateButtons: function (editor) {
                        return [
                            {
                                "label": "Editar",
                                "fn": function () { editor.submit() }
                            },
                            {
                                "label": "Cancelar",
                                "fn": function () { this.close() }
                            }
                        ];
                    },

                    getDeleteButtons: function (editor) {
                        return [
                            {
                                "label": "Remover",
                                "fn": function () { editor.submit() }
                            },
                            {
                                "label": "Cancelar",
                                "fn": function () { this.close() }
                            }
                        ];
                    }
                }
            }
        });
    }
)(jQuery);

$(function () {
    $.fn.dataTable.ext.errMode = function (e, settings, techNote, message) {
        console.log("Um erro acontece: " + message + "/" + techNote);
    };

    $.fn.dataTable.ext.buttons.RefreshTable = {
        text: '<span class="glyphicon glyphicon-refresh" aria-hidden="true"></span>',
        titleAttr: 'Atualizar',
        action: function (e, dt) {
            dt.ajax.reload();
        }
    };

    $.extend(true, $.fn.dataTable.defaults, {
        "searching": true,
        "paging": true,
        "ordering": true,
        "pagingType": "full_numbers",
        "lengthMenu": [
            [ 10, 20, 30, 40, 50, 75, 100 ],
            [ 10, 20, 30, 40, 50, 75, 100 ]
        ],
        "dom": $.datatable.dom.complete,
        "order": [[0, "asc"]],
        "buttons": [
            "pageLength",
            { extend: 'RefreshTable' },
        ],
        "language": {
            "decimal": ",",
            "thousands": ".",
            "buttons": {
                "pageLength": "Mostrar %d registros"
            },
            "emptyTable": "Nenhum registro encontrado",
            "info": "Mostrando de _START_ até _END_ de _TOTAL_ registros",
            "infoEmpty": "Mostrando 0 até 0 de 0 registros",
            "infoFiltered": "(Filtrados de _MAX_ registros)",
            "infoPostFix": "",
            "infoThousands": ".",
            "lengthMenu": "_MENU_ resultados por página",
            "loadingRecords": "Carregando...",
            "processing": "Processando...",
            "zeroRecords": "Nenhum registro encontrado",
            "search": "Pesquisar",
            "paginate": {
                "next": "Próximo",
                "previous": "Anterior",
                "first": "Primeiro",
                "last": "Último"
            },
            "aria": {
                "sortAscending": ": Ordenar colunas de forma ascendente",
                "sortDescending": ": Ordenar colunas de forma descendente"
            }
        }
    });

    $.extend(true, $.fn.dataTable.Editor.defaults, {
        "idSrc": "id",
        "i18n": {
            "datetime": {
                "previous": 'Anterior',
                "next": 'Posterior',
                "months": ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
                "weekdays": ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab']
            },
            "error": {
                "system": "Um erro fatal aconteceu"
            }
        }
    });
});



// WEBPACK FOOTER //
// src/datatables/DatatablesDefault.js